import { Box, Button, IconButton, InputAdornment, TextField, Typography, CircularProgress } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { LogoDarkMode } from '../assets/images'
import { GoogleIcon, LinkedInsmallIcon } from '../assets/icons'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom'
import AuthService from '../services/auth.service'
import { SocialProvider } from '../types/auth'
import AccountVerification from '../modals/AccountVerification'
import { config } from '../config'
import ConfirmMfa from '../modals/ConfirmMFA'
import { LeadsquaredService } from '../services/leadsquared/leadsquared.service'
import { toast } from 'react-toastify';
import { ArrowForward } from '@mui/icons-material';
// import { CleverTapService } from '../utils/clevertap.utils'

const Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [verificationDialogOpen, setVerificationDialogOpen] = useState(false);
    const [verificationData, setVerificationData] = useState({
        companyId: '',
        companyName: '',
        infLeadSquaredId: ''
    });
    const [confirmMfaDialogOpen, setConfirmMfaDialogOpen] = useState(false);
    const [confirmMfaData, setConfirmMfaData] = useState({
        challengeName: '',
        session: ''
    });

    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [fieldErrors, setFieldErrors] = useState({
        email: '',
        password: ''
    });

    // Track login page visit on component mount
    // useEffect(() => {
    //     const pageVisitData = {
    //         'Page Title': document.title,
    //         'Page URL': window.location.href,
    //         'UTM Source': localStorage.getItem('utm_source') || '',
    //         'UTM Medium': localStorage.getItem('utm_medium') || '',
    //         'UTM Campaign': localStorage.getItem('utm_campaign') || '',
    //         'UTM Content': localStorage.getItem('utm_content') || '',
    //         'UTM Term': localStorage.getItem('utm_term') || '',
    //     };
        
    //     CleverTapService.trackEvent('Login Page Visited', pageVisitData);
    // }, []);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error for the field being changed
        if (fieldErrors[name as keyof typeof fieldErrors]) {
            setFieldErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Reset errors
        setFieldErrors({
            email: '',
            password: ''
        });

        // Validate fields
        let hasErrors = false;
        const newFieldErrors = {
            email: '',
            password: ''
        };

        if (!formData.email) {
            newFieldErrors.email = 'Email is required';
            hasErrors = true;
        }

        if (!formData.password) {
            newFieldErrors.password = 'Password is required';
            hasErrors = true;
        }

        if (hasErrors) {
            setFieldErrors(newFieldErrors);
            return;
        }

        setIsLoading(true);

        // Track login attempt
        // const loginAttemptData = {
        //     'User Email': formData.email,
        //     'Page Title': document.title,
        //     'Page URL': window.location.href,
        //     'Timestamp': new Date().toISOString(),
        //     'Login Method': 'Email/Password'
        // };
        
        // CleverTapService.trackEvent('Login Attempted', loginAttemptData);

        try {
            const response = await AuthService.login({
                email: formData.email,
                password: formData.password
            });

            if (response?.data?.ChallengeName) {
                // Track MFA challenge
                // const mfaData = {
                //     'User Email': formData.email,
                //     'Challenge Name': response?.data?.ChallengeName,
                //     'Page Title': document.title,
                //     'Page URL': window.location.href,
                //     'Timestamp': new Date().toISOString(),
                // };
                // CleverTapService.trackEvent('MFA Challenge Required', mfaData);
                
                setConfirmMfaDialogOpen(true);
                setConfirmMfaData({
                    challengeName: response?.data?.ChallengeName || '',
                    session: response?.data?.Session || ''
                });
            } else {
                // Track successful login
                // const successData = {
                //     'User Email': formData.email,
                //     'Page Title': document.title,
                //     'Page URL': window.location.href,
                //     'Timestamp': new Date().toISOString(),
                //     'Login Method': 'Email/Password'
                // };
                // CleverTapService.trackEvent('Login Successful', successData);

                // Update user profile in CleverTap
                // const userData = {
                //     Email: formData.email,
                //     Name: formData.email.split('@')[0], // Use email prefix as name if no name available
                // };
                // CleverTapService.updateUserProfile(userData);

                navigate('/dashboard/overview?redirect=easywebinar');
            }

        } catch (err: any) {
            // Track login error
            // const errorData = {
            //     'User Email': formData.email,
            //     'Error Type': err.message || 'Unknown Error',
            //     'Page Title': document.title,
            //     'Page URL': window.location.href,
            //     'Timestamp': new Date().toISOString(),
            //     'Login Method': 'Email/Password'
            // };
            // CleverTapService.trackError('Login Error', err.message || 'Unknown Error', { Email: formData.email }, errorData);

            if (err.message === "UserNotConfirmedException") {
                // Track user not confirmed event
                // const notConfirmedData = {
                //     'User Email': formData.email,
                //     'Page Title': document.title,
                //     'Page URL': window.location.href,
                //     'Timestamp': new Date().toISOString(),
                // };
                // CleverTapService.trackEvent('User Not Confirmed', notConfirmedData);
                
                setVerificationData({
                    companyId: err.companyId || '',
                    companyName: err.companyName || '',
                    infLeadSquaredId: err.infLeadSquaredId || ''
                });
                setVerificationDialogOpen(true);
            } else {
                toast.error(err.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleSocialSignIn = (provider: SocialProvider) => {
        // Track social login attempt
        // const socialLoginData = {
        //     'Provider': provider,
        //     'Page Title': document.title,
        //     'Page URL': window.location.href,
        //     'Timestamp': new Date().toISOString(),
        //     'Login Method': 'Social'
        // };
        // CleverTapService.trackEvent('Social Login Attempted', socialLoginData);

        const authUrl = config.sso_auth_url;

        // Create state parameter with additional metadata
        const stateData = {
            isRegistration: false,
            timestamp: Date.now(),
        };

        const baseParams = {
            client_id: config.sso_client_id,
            response_type: 'code',
            scope: 'email openid profile phone',
            redirect_uri: `${window.location.origin}/auth/sso/callback`,
            state: JSON.stringify(stateData),
            prompt: 'select_account'
        };

        const params = new URLSearchParams({
            ...baseParams,
            identity_provider: provider,
        });

        window.location.href = `${authUrl}?${params.toString()}`;
    };

    const handleGoogleSignIn = () => handleSocialSignIn('Google');
    const handleMicrosoftSignIn = () => handleSocialSignIn('Microsoft');
    const handleLinkedinSignIn = () => handleSocialSignIn('Linkedin');

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const handleVerificationDialogClose = () => {
        setVerificationDialogOpen(false);
    };

    const handleVerificationDialogProceed = async () => {
        setVerificationDialogOpen(false);
        setIsLoading(true);
        
        // Track email verification completion
        // const verificationData = {
        //     'User Email': formData.email,
        //     'Page Title': document.title,
        //     'Page URL': window.location.href,
        //     'Timestamp': new Date().toISOString(),
        // };
        // CleverTapService.trackEvent('Email Verification Completed', verificationData);
        
        try {
            const LsData = await LeadsquaredService.getLeadsByEmail(formData.email);
            const LsId = (LsData as any).ProspectID;
            await LeadsquaredService.joinActivity({ id: LsId, activityEvent: 205, activityValue: "Email Verified" });
            const leadData = {
                "leadId": LsId,
                "fields": [
                    { "Attribute": "mx_Status", "Value": "Active" }
                ]
            }
            await LeadsquaredService.updateLsField(leadData);
            
            // Update user profile in CleverTap after verification
            // const userData = {
            //     Email: formData.email,
            //     Name: formData.email.split('@')[0],
            // };
            // CleverTapService.updateUserProfile(userData);
            
            navigate('/dashboard/overview?redirect=easywebinar');
        } catch (error) {
            console.error('Error updating lead data:', error);
            // Even if there's an error, still navigate to dashboard
            navigate('/dashboard/overview?redirect=easywebinar');
        } finally {
            setIsLoading(false);
        }
    };

    const handleConfirmMfaDialogClose = () => {
        setConfirmMfaDialogOpen(false);
    };

    const handleConfirmMfaDialogProceed = () => {
        // Track MFA completion
        // const mfaCompletionData = {
        //     'User Email': formData.email,
        //     'Page Title': document.title,
        //     'Page URL': window.location.href,
        //     'Timestamp': new Date().toISOString(),
        // };
        // CleverTapService.trackEvent('MFA Completed', mfaCompletionData);
        
        // Update user profile in CleverTap after MFA
        // const userData = {
        //     Email: formData.email,
        //     Name: formData.email.split('@')[0],
        // };
        // CleverTapService.updateUserProfile(userData);
        
        handleConfirmMfaDialogClose();
        navigate('/dashboard/overview?redirect=easywebinar');
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            width: '100vw',
            background: `
            linear-gradient(180deg, #010007 26.92%, #AC8DFF 100%),
            linear-gradient(180deg, #FFFFEF 0%, #FFF 100%)
        `,
            fontFamily: 'Inter',
        }}>
            {/* Header */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: { xs: "16px 24px", sm: "24px 32px" },
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img src={LogoDarkMode} alt="logo" style={{ height: 24, cursor: 'pointer', maxWidth: '100%' }} onClick={() => window.open('https://easywebinar.com/', '_blank')} />
                </Box>
                <Button
                    variant="contained"
                    endIcon={<ArrowForward />}
                    size="small"
                    onClick={() => navigate('/signup')}
                    sx={{
                        bgcolor: '#6066E9',
                        color: '#fff',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        '&:hover': { bgcolor: '#4B4EB5' }
                    }}
                >
                    Sign Up
                </Button>
            </Box>

            {/* Main Content */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                minHeight: { xs: 'calc(100vh - 120px)', sm: 'calc(100vh - 100px)', md: 'calc(100vh - 80px)' },
            }}>
                <Box sx={{
                    bgcolor: '#ffffff',
                    borderRadius: '18px',
                    boxShadow: '0 4px 32px 0 rgba(0,0,0,0.15)',
                    width: { xs: '98%', sm: 600 },
                    maxWidth: 600,
                    p: { xs: '24px 16px', sm: 4, lg: 6 },
                    mx: { xs: 1, sm: 'auto' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    border: '1.5px solid #e5e7eb',
                    // Autofill override for all inputs inside the card
                    '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
                        WebkitTextFillColor: '#1f2937',
                        caretColor: '#1f2937',
                        transition: 'background-color 5000s ease-in-out 0s',
                    },
                    '& input:-webkit-autofill:focus': {
                        WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
                        WebkitTextFillColor: '#1f2937',
                    },
                    '& input:-webkit-autofill:hover': {
                        WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
                        WebkitTextFillColor: '#1f2937',
                    },
                }}>
                    {/* Welcome Text */}
                    <Typography color="#1f2937" fontWeight={700} textAlign="center" mb={0.5}
                        fontSize={{ xs: 22, sm: 26, md: 28, lg: 30 }}
                        sx={{ lineHeight: { xs: '32px', sm: '36px', md: '40px' } }}>
                        Welcome back!
                    </Typography>
                    <Typography color="#6b7280" textAlign="center" mb={3}
                        fontSize={{ xs: 13, sm: 15, md: 16 }}
                        sx={{ lineHeight: { xs: '20px', sm: '22px', md: '24px' } }}>
                        Log in to your dashboard
                    </Typography>
                    {/* Social Buttons */}
                    <Box width="100%" display="flex" gap={2} mb={2}>
                        <Button
                            onClick={handleGoogleSignIn}
                            variant="outlined"
                            fullWidth
                            sx={{
                                bgcolor: '#ffffff',
                                color: '#374151',
                                borderColor: '#d1d5db',
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontWeight: 500,
                                fontSize: 16,
                                py: 0.8,
                                minHeight: 38,
                                transition: 'background 0.2s, border-color 0.2s',
                                '&:hover': {
                                    bgcolor: '#f9fafb',
                                    borderColor: '#6066E9',
                                },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.2,
                            }}
                            startIcon={<GoogleIcon />}
                        >
                            Google
                        </Button>
                        <Button
                            onClick={handleLinkedinSignIn}
                            variant="outlined"
                            fullWidth
                            sx={{
                                bgcolor: '#ffffff',
                                color: '#374151',
                                borderColor: '#d1d5db',
                                borderRadius: '8px',
                                textTransform: 'none',
                                fontWeight: 500,
                                fontSize: 16,
                                py: 0.8,
                                minHeight: 38,
                                transition: 'background 0.2s, border-color 0.2s',
                                '&:hover': {
                                    bgcolor: '#f9fafb',
                                    borderColor: '#6066E9',
                                },
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.2,
                            }}
                            startIcon={<LinkedInsmallIcon />}
                        >
                            LinkedIn
                        </Button>
                    </Box>
                    {/* Divider with Or */}
                    <Box width="100%" display="flex" alignItems="center" mb={3} mt={1}>
                        <Box flex={1} height={0} borderTop="2px solid #e5e7eb" />
                        <Typography color="#9ca3af" px={2} fontWeight={500} letterSpacing={1} sx={{ whiteSpace: 'nowrap', fontSize: { xs: 13, sm: 15 } }}>Or</Typography>
                        <Box flex={1} height={0} borderTop="2px solid #e5e7eb" />
                    </Box>
                    {/* Form Fields */}
                    <Box component="form" onSubmit={handleSubmit} width="100%">
                        <TextField
                            variant="outlined"
                            label="Email address/Username"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            error={!!fieldErrors.email}
                            helperText={fieldErrors.email}
                            fullWidth
                            autoComplete="email"
                            sx={{
                                mb: 3,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: '#ffffff',
                                    color: '#1f2937',
                                    transition: 'border-color 0.2s',
                                },
                                '& .MuiInputLabel-root': {
                                    color: '#6b7280',
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#6066E9',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#d1d5db',
                                },
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6066E9',
                                },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6066E9',
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: '14px 16px',
                                },
                                input: { color: '#1f2937' },
                            }}
                            InputLabelProps={{ style: { color: '#6b7280' } }}
                        />
                        <TextField
                            variant="outlined"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            error={!!fieldErrors.password}
                            helperText={fieldErrors.password}
                            fullWidth
                            autoComplete="current-password"
                            sx={{
                                mb: 1,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                    bgcolor: '#ffffff',
                                    color: '#1f2937',
                                    transition: 'border-color 0.2s',
                                },
                                '& .MuiInputLabel-root': {
                                    color: '#6b7280',
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#6066E9',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#d1d5db',
                                },
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6066E9',
                                },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#6066E9',
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: '14px 16px',
                                },
                                input: { color: '#1f2937' },
                            }}
                            InputLabelProps={{ style: { color: '#6b7280' } }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            onMouseUp={handleMouseUpPassword}
                                            edge="end"
                                            sx={{ color: '#6b7280' }}
                                        >
                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {/* Forgot password */}
                        <Box display="flex" justifyContent="flex-end" mb={3} mt={2}>
                            <Typography
                                variant="body2"
                                color="#6066E9"
                                component="a"
                                onClick={() => navigate('/forgot-password')}
                                sx={{
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                    py: 1.5,
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    },
                                }}
                            >
                                Forgot your password?
                            </Typography>
                        </Box>
                        {/* Login Button */}
                        <Button
                            variant="contained"
                            type="submit"
                            disabled={isLoading}
                            fullWidth
                            sx={{
                                bgcolor: '#6066E9',
                                color: '#fff',
                                borderRadius: '8px',
                                fontWeight: 600,
                                fontSize: 17,
                                py: 1.3,
                                mb: 2,
                                textTransform: 'none',
                                boxShadow: 'none',
                                '&:hover': { bgcolor: '#4B4EB5' },
                            }}
                        >
                            {isLoading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Log In'}
                        </Button>
                    </Box>
                    {/* Create Account Link */}
                    <Typography color="#6b7280" fontSize={15} textAlign="center" mt={1}>
                        Don&apos;t have an account?{' '}
                        <Box component="span" color="#6066E9" sx={{ cursor: 'pointer', textDecoration: 'none', fontSize: { xs: 14, sm: 15 }, '&:hover': { textDecoration: 'underline' } }} onClick={() => navigate('/signup')}>
                            Create An Account
                        </Box>
                    </Typography>
                    {/* Footer */}
                    <Box width="100%" mt={4}>
                        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                            <Typography color="#9ca3af" sx={{ fontSize: { xs: 11, sm: 13 } }}>
                                &copy; 2025 All Rights Reserved
                            </Typography>
                            <Box display="flex" gap={2}>
                                <Link href="https://easywebinar.com/terms-conditions/" target="_blank" rel="noopener noreferrer" sx={{ color: '#9ca3af', fontSize: { xs: 11, sm: 13 }, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Terms of Service</Link>
                                <Link href="https://easywebinar.com/privacy/" target="_blank" rel="noopener noreferrer" sx={{ color: '#9ca3af', fontSize: { xs: 11, sm: 13 }, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Privacy Policy</Link>
                                <Link href="https://easywebinar.com/gdpr/" target="_blank" rel="noopener noreferrer" sx={{ color: '#9ca3af', fontSize: { xs: 11, sm: 13 }, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>Security</Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* Modals */}
            <AccountVerification
                open={verificationDialogOpen}
                onClose={handleVerificationDialogClose}
                onProceed={handleVerificationDialogProceed}
                phoneNumber=""
                email={formData.email}
                password={formData.password}
                companyId={verificationData.companyId}
                companyName={verificationData.companyName}
                infLeadSquaredId={verificationData.infLeadSquaredId}
            />
            <ConfirmMfa
                open={confirmMfaDialogOpen}
                onClose={handleConfirmMfaDialogClose}
                onProceed={handleConfirmMfaDialogProceed}
                phoneNumber=""
                email={formData.email}
                challengeName={confirmMfaData.challengeName}
                session={confirmMfaData.session}
            />
        </Box>
    )
}
export default Login
